import {InputElementType, Validation, type ValidationResponse, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";
import {LocalDate} from "../../../common/utils/dates/localDate";

export class ValidDate extends Validation {

    private inputSupplier: () => HTMLInputElement;

    public constructor(
        messageText: string,
        inputSupplier: () => HTMLInputElement
    ) {
        super(messageText, WarningLevel.ERROR);
        this.inputSupplier = inputSupplier;
    }

    protected valid(value: unknown): boolean {
        const validityState = this.inputSupplier().validity;
        if (validityState.badInput) {
            return false;
        }

        if (value === "") {
            return true;
        }

        const dateFromExpression = LocalDate.fromDateExpression(value as string);
        return dateFromExpression.isValid();
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value: T): void {
        inputElement.setType(InputElementType.DATE);

        const validationResponse: ValidationResponse = this.checkValidity(value);
        if (!validationResponse.valid) {
            inputElement.addMessage({warningLevel: validationResponse.warningLevel, message: this.errorText});
        }
    }
}